// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-all-js": () => import("./../../../src/pages/all.js" /* webpackChunkName: "component---src-pages-all-js" */),
  "component---src-pages-coffeetables-js": () => import("./../../../src/pages/coffeetables.js" /* webpackChunkName: "component---src-pages-coffeetables-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-lamps-js": () => import("./../../../src/pages/lamps.js" /* webpackChunkName: "component---src-pages-lamps-js" */),
  "component---src-pages-shelves-js": () => import("./../../../src/pages/shelves.js" /* webpackChunkName: "component---src-pages-shelves-js" */),
  "component---src-pages-sofas-js": () => import("./../../../src/pages/sofas.js" /* webpackChunkName: "component---src-pages-sofas-js" */)
}

